import {
    Dic
} from '$utils'
const tableOption = function (that) {
    return {

        add: '新增',
        edit: '修改',
        view: '详情',
        page: true,
        selection: true,
        index: false,
        indexLabel: '序号',
        refreshBtn: false,
        columnBtn: false,
        stripe: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'left',
        size: 'small',
        maxHeight: '100%',
        labelWidth: '120px',
        menuAlign: 'center',
        addformslot: true,
        searchMenuSpan: 8,
        searchBtn: false,
        dialogHeight: 200,
        dialogWidth: '750px',
        emptyText: '暂无数据',
        column: [{
                label: '通信ID',
                prop: 'thirdDeviceId',
                viewDisplay: true,
                overHidden: true,
                span: 12,
            },
            {
                label: '名称',
                prop: 'deviceName',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                search: true,

            },
            {
                label: '制造厂',
                prop: 'deviceExtendInfoMap',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                formatter: function (row, value) {
                    return row.deviceExtendInfoMap ? (row.deviceExtendInfoMap.manufacturer || '') : ""
                },
                viewFormatter: (row, value) => {
                    return value ? value.manufacturer || '' : ''
                },

            },
            {
                label: '规格型号',
                prop: 'deviceVersion',
                viewDisplay: true,
                overHidden: true,
                span: 12,
            },
            {
                label: '介质属性',
                prop: 'typeMark',
                viewDisplay: true,
                overHidden: true,
                span: 12,
                type: 'select',
                dicData: Dic.find('SENU110'),
                viewFormatter: (row, value) => {
                    if (value) {
                        return Dic.findByValue('SENU110', Number(value))
                    }
                    return ''
                },
                formatter: function (row, value) {
                    return value ? Dic.findByValue('SENU110', value) : ''
                },


            },
            {
                label: 'IP地址',
                prop: 'deviceHost',
                viewDisplay: true,
                overHidden: true,
                span: 12,
            },
            {
                label: '备注',
                prop: 'thirdDeviceDesc',
                viewDisplay: true,
                overHidden: true,
                span: 24,
                type: 'textarea'
            },
        ]
    }
}
export default tableOption